<ion-app>
	<ion-content>
	<ion-split-pane contentId="main-content" when="xl">
		@if (show_sidebar) {
			<app-sidebar></app-sidebar>
		}
		<ion-router-outlet id="main-content"></ion-router-outlet>
	</ion-split-pane>
	</ion-content>

	@if (!is_cookie_accepted) {
		<ion-footer>
			<ion-toolbar>
				<div class="ion-card-header-flex ion-padding-start ion-padding-end">
					<span>{{'general.cookies.text' | translate}}</span>
					<ion-button size="small" (click)="acceptCookie()">{{'general.accept' | translate}}</ion-button>
				</div>
			</ion-toolbar>
		</ion-footer>
	}
</ion-app>